import { Box, Table, TableHead, TableRow, TableCell, TableBody, CircularProgress } from "@mui/material";

export const KarkaDetail = ({ data = [], loading = false, maxWidth, minWidth, minHeight }) => {
  return (
    <Box
      sx={{
        textAlign: "center",
        position: "relative",
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: minHeight,
          }}
        >
          <CircularProgress />
        </Box>
      ) : data.length ? (
        <Table
          size="small"
          sx={{
            "& .MuiTableCell-root": {
              borderBottom: "none",
              padding: "2px 6px",
              fontSize: 13,
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell><strong>Planet</strong></TableCell>
              <TableCell><strong>Karka</strong></TableCell>
              <TableCell><strong>Degree</strong></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.planet}</TableCell>
                <TableCell>{item.karka}</TableCell>
                <TableCell>{item.degree?.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: minHeight,
            bgcolor: "#f5f5f5",
          }}
        >
          No data available
        </Box>
      )}
    </Box>
  );
};
